'use es6';

import { BAR, COLUMN, COMBINATION, LINE, AREA } from 'reporting-data/constants/chartTypes';
import { getReportStackingType } from 'reporting-data/report/reportGetters';
import { processReportStacking } from 'reporting-snowflake/relational/visualize/visual-mappers/shared';
import { getDataLabelsStyle, getStackLabelStyle } from 'reporting-snowflake/shared/lib/style';
export const applyHideDataLabels = (visualization, report) => {
  const chartType = report.get('chartType');
  const hideDataLabels = report.getIn(['displayParams', 'hideDataLabels']);
  const stacked = report.getIn(['displayParams', 'stacked']);
  const stackingType = getReportStackingType(report);
  const stackingValue = processReportStacking(stacked, stackingType);

  // see here https://git.hubteam.com/HubSpot/reporting/blob/cbd1dabbbe92b64b61dd6e88fc44eb3d1361b63b/reporting-ui-components/static-2.58629/js/reports/decorators/ConfigOptionsDecorator/plotOptions.js#L62
  const isBarType = [BAR, COLUMN, COMBINATION].includes(chartType);
  if (isBarType) {
    return visualization.setIn(['style', 'dataLabels'], getDataLabelsStyle(stackingValue, !hideDataLabels)).setIn(['style', 'stackLabels'], getStackLabelStyle(stackingValue, !hideDataLabels));
  }
  if (hideDataLabels === undefined) {
    // see here https://git.hubteam.com/HubSpot/reporting/blob/6880b9b47f74a06fe2ba95e97f9c718102f59a02/reporting-ui-components/static-2.58629/js/reports/charts/LineChart/chartOptions.js#L46
    return chartType === LINE || chartType === AREA ? visualization.setIn(['style', 'dataLabels'], false) : visualization;
  }
  return visualization.setIn(['style', 'dataLabels'], !hideDataLabels);
};